import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import { formatDateTime } from '@atheneum/api/dist/lib'

import Action from '@components/Action'
import ArrowBackIcon from '@components/Icon/ArrowBack'
import Spinner from '@components/spinner'

class EplEmails extends Component {
  static propTypes = {
    eplEmailStore: PropTypes.object,
    match: PropTypes.shape({
      params: PropTypes.shape({
        eplId: PropTypes.string
      }).isRequired,
      url: PropTypes.string
    }).isRequired
  }

  constructor (props) {
    super(props)

    const { eplEmailStore, match } = props

    eplEmailStore.getEplEmails(match.params.eplId)
  }

  generateBackLink = () => {
    const { match } = this.props
    return (
      match.url.substr(0, match.url.lastIndexOf('/epl-emails')) +
      '/email-tracking'
    )
  }

  renderDateTime (datetime) {
    if (!datetime) return '-'
    return formatDateTime(datetime, false)
  }

  render () {
    const { loading, eplEmails } = this.props.eplEmailStore

    if (loading) return <Spinner />

    return (
      <DocumentTitle title={'EPL emails | Atheneum Partners'}>
        <div className='invoice-wrapper animate-intro'>
          <div className='actions-wrapper actions-wrapper__noTop actions-wrapper--space-between'>
            <ul className='actions left-list'>
              <Link to={this.generateBackLink()}>
                <Action>
                  <li>
                    <ArrowBackIcon />
                    <span>Project email tracking</span>
                  </li>
                </Action>
              </Link>
            </ul>
          </div>
          <hr className='hr-separator hr-separator--light' />
          <h2>
            <span>
              Expert:{' '}
              <Link to={'/expert/' + eplEmails[0].epl.expert.id}>
                {eplEmails[0].epl.expert.fullName}
              </Link>
            </span>
          </h2>
          {eplEmails.map(eplEmail => {
            const sendEvent = eplEmail.events.find(e => e.event === 'send')
            const openEvent = eplEmail.events.find(e => e.event === 'open')
            const clickEvent = eplEmail.events.find(e => e.event === 'click')
            return (
              <div key={eplEmail.id}>
                <hr className='hr-separator hr-separator--light' />
                <h2>{eplEmail.subject}</h2>
                <div className='details-list'>
                  <div>To:</div>
                  <div>{eplEmail.email || '-'}</div>
                </div>
                <div className='details-list'>
                  <div>From:</div>
                  <div>{eplEmail.from.email || '-'}</div>
                </div>
                <div className='details-list'>
                  <div>Subject:</div>
                  <div>{eplEmail.subject || '-'}</div>
                </div>
                <div className='details-list'>
                  <div>Employee:</div>
                  <div>{eplEmail.employee.fullName || '-'}</div>
                </div>
                <div className='details-list'>
                  <div>Sent:</div>
                  <div>{this.renderDateTime(eplEmail.created_at)}</div>
                </div>
                <div className='details-list'>
                  <div>Delivered:</div>
                  <div>
                    {this.renderDateTime(sendEvent && sendEvent.timestamp)}
                  </div>
                </div>
                <div className='details-list'>
                  <div>Opened:</div>
                  <div>
                    {this.renderDateTime(openEvent && openEvent.timestamp)}
                  </div>
                </div>
                <div className='details-list'>
                  <div>Clicked:</div>
                  <div>
                    {this.renderDateTime(clickEvent && clickEvent.timestamp)}
                  </div>
                </div>
                <h2>Content</h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: eplEmail.htmlBody
                  }}
                />
              </div>
            )
          })}
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('eplEmailStore')(observer(EplEmails))
